
import { createRouter, createWebHistory } from 'vue-router';
import DashboardPage from '../components/DashboardPage.vue';
import ClientsCRUD from '../components/ClientsCRUD.vue';
import DailyReport from '../components/DailyReport.vue';
import AtencionesPage from '../components/AtencionesPage.vue';
import ManicuristasCRUD from '../components/ManicuristasCRUD.vue';
import ProductsCRUD from '../components/ProductsCRUD.vue';
import LoginPage from '../components/LoginPage.vue';

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: LoginPage,
  },
  {
    path: '/',
    name: 'Dashboard',
    component: DashboardPage,
  },
  {
    path: '/clients',
    name: 'Clients',
    component: ClientsCRUD,
  },
  {
    path: '/daily-report',
    name: 'DailyReport',
    component: DailyReport,
  },
  {
    path: '/atenciones',
    name: 'Atenciones',
    component: AtencionesPage,
  },
  {
    path: '/manicuristas',
    name: 'Manicuristas',
    component: ManicuristasCRUD,
  },
  {
    path: '/products',
    name: 'Products',
    component: ProductsCRUD,
  },
  // Redirect any unknown paths to the dashboard
  { 
    path: '/:pathMatch(.*)*', 
    redirect: '/' 
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// The problematic beforeEach guard has been removed.
// Logic is now handled in main.js

export default router;
